import { render } from "./QuizBottomBar.vue?vue&type=template&id=1b41833c"
import script from "./QuizBottomBar.vue?vue&type=script&lang=js"
export * from "./QuizBottomBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__